import React, { useEffect, useState } from "react";
import { GoogleLogin } from "@react-oauth/google";
import jwt_decode from "jwt-decode";
import { Modal } from "antd";
import useLogin from "../../hooks/useLogin";

import "./login.scss";
const Login = () => {
  const [openLoginModal, setOpen] = useState(false);
  const { login } = useLogin();

  const googleLogin = async (data) => {
    // if (data.email) {
    //   const response = await ConfigApi.login(data);
    //   if (response) {
    //     localStorage.setItem("token", respon q se.token);
    //     localStorage.setItem("ieuser", JSON.stringify(data));
    //     setOpen(false);
    //   }
    //   if (isLoggedIn) {
    //     setSavePresetModal(false);
    //   } else {
    //     setSavePresetModal(true);
    //   }
    // }
  };
  return (
    <div className="css-zlebhn">
      <Modal
        title=""
        open={openLoginModal}
        closable={true}
        onCancel={() => setOpen(false)}
        footer={null}
        onClose
      >
        <div
          style={{
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            marginTop: "20px",
          }}
        >
          <GoogleLogin
            onSuccess={(credentialResponse) => {
              var decoded = jwt_decode(credentialResponse.credential);
              //googleLogin(decoded);
              login(decoded.email, decoded.name);
            }}
            onError={() => {
              console.log("Login Failed");
            }}
          />
        </div>
      </Modal>
      <div className="css-qe3dct">
        <div className="css-uen344">
          <div className="css-uewl2b">
            <img style={{ width: "70px" }} src="/images/logo.png" alt="" />
          </div>
          <p className="css-kyfvq9" font="Roboto">
            FlixStudio Dashboard
          </p>
          {/* <div className="css-145q57r">
            <button onClick={() => setOpen(true)} className="css-16jg4tx">
              <span style={{ marginTop: "5px" }}>
                <svg
                  className="css-vubbuv"
                  focusable="false"
                  aria-hidden="true"
                  viewBox="0 0 24 24"
                  data-testid="GoogleIcon"
                  style={{ fontSize: "18px" }}
                >
                  <path d="M12.545,10.239v3.821h5.445c-0.712,2.315-2.647,3.972-5.445,3.972c-3.332,0-6.033-2.701-6.033-6.032s2.701-6.032,6.033-6.032c1.498,0,2.866,0.549,3.921,1.453l2.814-2.814C17.503,2.988,15.139,2,12.545,2C7.021,2,2.543,6.477,2.543,12s4.478,10,10.002,10c8.396,0,10.249-7.85,9.426-11.748L12.545,10.239z"></path>
                </svg>
              </span>
              <GoogleLogin
                onSuccess={(credentialResponse) => {
                  var decoded = jwt_decode(credentialResponse.credential);
                  console.log(decoded);
                  login(decoded.email, decoded.name);
                }}
                onError={() => {
                  console.log("Login Failed");
                }}
              />
            </button>
          </div> */}
          <div
            style={{
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              marginTop: "20px",
            }}
          >
            <GoogleLogin
              onSuccess={(credentialResponse) => {
                var decoded = jwt_decode(credentialResponse.credential);
                //googleLogin(decoded);
                login(decoded.email, decoded.name, credentialResponse.credential);
              }}
              onError={() => {
                console.log("Login Failed");
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
